// extracted by mini-css-extract-plugin
export default {"root":"pWWcs_Px","card":"Xuci95GW","card__next":"mL3qsSK6","card__next_visible":"vmQs2_DE","root__will_change":"Z2JgZx4b"};